const img = require('./Square Frame.svg'); export default img;